import React from 'react';
import { cn } from './utils';

interface AnimatedBadgeProps {
  children: React.ReactNode;
  className?: string;
}

export function AnimatedBadge({ children, className }: AnimatedBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        "text-white font-semibold shadow-sm",
        className
      )}
      style={{
        background: 'linear-gradient(90deg, #8b5cf6, #ec4899, #3b82f6, #8b5cf6)',
        backgroundSize: '300% 100%',
        backgroundPosition: '0% 50%',
        animation: 'gradient-x 3s ease infinite',
      }}
    >
      {children}
    </span>
  );
} 